module.exports = __webpack_public_path__ + "static/media/icon_card_selected.9e1c2c18.svg";